import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDynamicTable, renderReportfield} from '../../utils/templateUtils';
import './donorstimulationchecklist.scss';

export default function DonorStimulationCheckList(props) {
  const [checkListRows, setCheckListRows] = useState([
    {sno: '1', factors: 'HB', female: ''},
    {sno: '2', factors: 'PCV', female: ''},
    {sno: '3', factors: 'PLT', female: ''},
    {sno: '4', factors: 'RBS', female: ''},
    {sno: '5', factors: 'HBA1C', female: ''},
    {sno: '6', factors: 'TSH', female: ''},
    {sno: '7', factors: 'HIV', female: ''},
    {sno: '8', factors: 'VDRL', female: ''},
    {sno: '9', factors: 'HBSAG', female: ''},
    {sno: '10', factors: 'HCV', female: ''},
    {sno: '11', factors: 'PTINR', female: ''},
    {sno: '12', factors: 'BLOOD GROUP', female: ''},
    {sno: '13', factors: 'UREA', female: ''},
    {sno: '14', factors: 'CREA', female: ''},
    {sno: '15', factors: 'ECG', female: ''},
    {sno: '16', factors: 'X ray', female: ''},
    {sno: '17', factors: 'ECG', female: ''}
  ]);

  const checkListHeaders = [
    {key: 'sno', label: 'S.No', inputType: 'text', readOnly: true},
    {key: 'factors', label: 'FACTORS', inputType: 'text', readOnly: true},
    {key: 'female', label: 'FEMALE'}
  ];

  const [showTables, setShowTables] = useState({
    checkList: true
  });

  const [formData, setFormData] = useState({
    nextAppointment: ''
  });
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);

  const handleChange = e => {
    const {name, value} = e.target;
    setFormData({...formData, [name]: value});
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && props.patientsData.p_uhid.length === 10) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('donorStimulationCheckListReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: 'DONOR STIMULATION CHECK LIST',
              template_type: 'DONOR STIMULATION CHECK LIST'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='DonorStimulationCheckListTemplate'>
      <div id='DonorStimulationCheckListTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>DONOR STIMULATION CHECK LIST</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          {showTables.checkList && (
            <TemplateTable
              id='checkList'
              title=''
              headers={checkListHeaders}
              rows={checkListRows}
              onRowsChange={(id, newRows) => setCheckListRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('checkList', setShowTables)}
            />
          )}
        </div>

        <div className='d-flex align-items-start py-2'>
          <label htmlFor='advice' className='fw-bold' style={{width: '180px'}}>
            ADVICE:
          </label>
          <textarea className='Textarea' placeholder='Advice' id='advice' name='advice' onChange={handleChange} rows='3' cols='100' />
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='donorStimulationCheckListReport'>
        <div id='donorStimulationCheckListReportWrap'>
          <Headers />
          <p className='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '5px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>DONOR STIMULATION CHECK LIST</h4>
          </div>

          {showTables.checkList && renderDynamicTable('', ['S.No', 'FACTORS', 'FEMALE'], ['sno', 'factors', 'female'], checkListRows)}

          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('ADVICE:', formData.advice)}</div>

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p className='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
